import { Box, CircularProgress, Typography } from "@mui/material";

import { useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getNotifications } from "../../../../redux/actions/room";
import { formatDateAndHour } from "../../../../utils/datetime";
import {
  CardHeader,
  CardHeaderText,
  Container,
  MessageBox,
  MessagesContainer,
  MessageText,
  MessageTime,
  StyledCard,
  StyledCardContent,
  WelcomeText,
} from "../../../styled/ProfesionalNotifications";

const ProfesionalNotifications = () => {
  const esLayoutMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const idRoom = searchParams.get("id");

  const notifications = useSelector((state) => state.room.notifications);
  const {
    apellidoNombrePaciente,
    apellidoNombreProfesional,
    fechaHoraAgendada,
    duracionAgendada,
  } = useSelector((state) => state.call.call.data);

  useEffect(() => {
    dispatch(getNotifications(idRoom));
    const intervalId = setInterval(() => {
      dispatch(getNotifications(idRoom));
    }, 60000);
    return () => clearInterval(intervalId);
  }, [dispatch, idRoom]);

  return (
    <Container esLayoutMobile={esLayoutMobile}>
      <WelcomeText variant="h5" esLayoutMobile={esLayoutMobile}>
        Bienvenido/a! {apellidoNombrePaciente.toUpperCase()}. Tu cita está
        programada para el {formatDateAndHour(fechaHoraAgendada).fecha} a las{" "}
        {formatDateAndHour(fechaHoraAgendada).hora}. La duración aproximada es
        de {duracionAgendada} minutos. En breve el Dr/a.{" "}
        {apellidoNombreProfesional.toUpperCase()} se conectará...
      </WelcomeText>
      <StyledCard esLayoutMobile={esLayoutMobile}>
        <CardHeader>
          <CardHeaderText variant="h6" esLayoutMobile={esLayoutMobile}>
            Mensajes del Dr/a. {apellidoNombreProfesional}
          </CardHeaderText>
        </CardHeader>
        <StyledCardContent esLayoutMobile={esLayoutMobile}>
          <MessagesContainer esLayoutMobile={esLayoutMobile}>
            {notifications.loading ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
              </Box>
            ) : notifications.data.length > 0 ? (
              notifications.data.map((msg) => (
                <MessageBox key={msg.id}>
                  <MessageText variant="body2" esLayoutMobile={esLayoutMobile}>
                    {msg.mensaje}
                    <MessageTime>{msg.hora}</MessageTime>
                  </MessageText>
                </MessageBox>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary" align="center">
                No hay notificaciones.
              </Typography>
            )}
          </MessagesContainer>
        </StyledCardContent>
      </StyledCard>
    </Container>
  );
};

export default ProfesionalNotifications;
